if (!window._babelPolyfill) {
    require('babel-polyfill');
}


// WEBPACK FOOTER //
// ./build/templates/polyfill-fix.js